import useMediaQuery from '@mui/material/useMediaQuery'

/**
 * Is this a small screen right now?
 *
 * Replaces `isMobile` from react-device-detect, which was imported in five files and is
 * three separate problems:
 *
 *   1. It is USER-AGENT sniffing, so it answers "is this a phone-shaped device", not
 *      "is the viewport narrow" — the question the layout actually has.
 *   2. It is evaluated once at MODULE LOAD, so it never responds to a resize, a rotation,
 *      or a window being dragged between monitors. An operator who narrows the window keeps
 *      the desktop tables; one who widens a phone browser keeps the mobile fork.
 *   3. It misfires on tablets, which is most of the ambiguous middle ground.
 *
 * Nav.jsx already did the right thing with useMediaQuery; this just makes it shared.
 *
 * 768px, not MUI's `sm` (600px): the desktop tables stay usable down to a tablet in
 * portrait, and 768 is the breakpoint the CSS modules in this repo already use.
 */
export const MOBILE_BREAKPOINT = '(max-width: 768px)'

export const useIsMobile = () => useMediaQuery(MOBILE_BREAKPOINT)

export default useIsMobile
